import React from "react";
import { Link, useLocation } from "react-router-dom";

// Full-screen experiments that should not get the site footer.
const NO_FOOTER = ["/oslo", "/telcofy-pin"];

const internalLinks = [
  { to: "/platform", label: "Platform" },
  { to: "/projects", label: "Projects" },
];

const externalLinks = [
  { href: "https://docs.telcofy.ai", label: "Docs" },
  { href: "https://docs.telcofy.ai/blog", label: "Blog" },
  { href: "https://app.telcofy.ai", label: "CityOS" },
];

const linkClass = "hover:text-brand-600 transition-colors";

const Footer = () => {
  const { pathname } = useLocation();
  if (NO_FOOTER.includes(pathname)) return null;

  return (
    <footer className="bg-paper border-t border-paper-300 py-10">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <img src="/brand/telcofy-mark.svg" alt="" className="h-6 w-auto" />
          <span className="wordmark text-lg">
            Telco<span className="fy">fy</span>
          </span>
          <span className="ml-3 text-sm text-ink-subtle hidden sm:inline">
            Human mobility analytics, made simple.
          </span>
        </div>
        <div className="flex items-center gap-5 text-sm text-ink-subtle flex-wrap">
          {internalLinks.map(({ to, label }) => (
            <Link key={to} to={to} className={linkClass}>
              {label}
            </Link>
          ))}
          {externalLinks.map(({ href, label }) => (
            <a key={href} href={href} target="_blank" rel="noopener noreferrer" className={linkClass}>
              {label}
            </a>
          ))}
          <Link to="/cookies" className={linkClass}>
            Cookies
          </Link>
          <span className="text-ink-faint">
            © {new Date().getFullYear()} Telcofy
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
